import { coreProjectLayout } from '@atlassian/jira-core-project-layout/src/index.tsx';
import { composeLayouts, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import {
	classicSoftwareProjectLayout,
	softwareProjectLayout,
} from '@atlassian/jira-software-project-layout/src/index.tsx';
import { userBoardLayout } from '@atlassian/jira-user-board-layout/src/index.tsx';

// TODO Remove this when all route paths are no longer ambiguous
export const genericProjectLayout: Layout = composeLayouts(
	classicSoftwareProjectLayout,
	coreProjectLayout,
	serviceProjectLayout,
	softwareProjectLayout,
	userBoardLayout,
);
